import {MenuDivider, MenuItem} from '@szhsin/react-menu'
import {EditIcon, HorizontalMoreIcon, TrashIcon} from '../../../icons'
import Dropdown from '../../core/dropdown'
import text from './text.json'
import {colors} from '../../../utils/colors'
import classNames from 'classnames'
import {useSelector} from 'react-redux'

const ActionButtons = ({
    onEdit,
    isEditBtnDisabled,
    showEdit = true,
    showDelete = true,
    onDelete
}) => {
    const isDarkMode = useSelector(state => state.sidebar.isDarkMode)

    return <Dropdown menuButton={<button className={classNames('table-action-btn', {
        dark: isDarkMode
    })}><HorizontalMoreIcon/></button>}>
        {showEdit && <MenuItem onClick={onEdit} disabled={isEditBtnDisabled}>
            <span className="d-flex"><EditIcon/></span>
            <span>{text.edit}</span>
        </MenuItem>}
        {showDelete &&
            <>
                <MenuDivider/>
                <MenuItem className="danger" onClick={onDelete}>
                    <span className="d-flex"><TrashIcon stroke={colors.colorRed}/></span>
                    <span>{text.delete}</span>
                </MenuItem>
            </>}
    </Dropdown>
}

export default ActionButtons
